import { render, staticRenderFns } from "./WhiteListPage.vue?vue&type=template&id=05bc843a"
import script from "./WhiteListPage.vue?vue&type=script&lang=js"
export * from "./WhiteListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports